// -------------------------------
// ROLE INTERFACES
// -------------------------------
export interface PendingRole {
    name?: string;
    status?: string; // active | inactive
}

export interface PendingDeleteRole {
    awaitingName?: boolean;
}
// -------------------------------
// CREATE ROLE — START
// -------------------------------
export const startCreateRoleFlow = (
    setPendingRole: (data: PendingRole | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void,
    nameFromIntent?: string
) => {
    if (nameFromIntent) {
        setPendingRole({ name: nameFromIntent });

        pushAIChat(`Should the role "${nameFromIntent}" be active or inactive?`);
        speak(`Should the role ${nameFromIntent} be active or inactive?`);
        return;
    }

    setPendingRole({});
    pushAIChat("Sure! What should the role be called?");
    speak("What should the role be called?");
};
// -------------------------------
// CREATE ROLE — PROCESS
// -------------------------------
export const processPendingRole = (
    text: string,
    pending: PendingRole,
    setPendingRole: (data: PendingRole | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void
) => {

    // STEP 1 — ROLE NAME
    if (!pending.name) {
        const cleanName = text.replace(/[^a-zA-Z0-9 ]/g, "").trim();

        if (!cleanName) {
            pushAIChat("Please provide a valid role name.");
            speak("Please provide a valid role name.");
            return;
        }

        setPendingRole({ ...pending, name: cleanName });

        pushAIChat(`Should the role "${cleanName}" be active or inactive?`);
        speak(`Should the role ${cleanName} be active or inactive?`);
        return;
    }

    // STEP 2 — STATUS
    if (!pending.status) {
        const status = text.toLowerCase().includes("inactive")
            ? "inactive"
            : "active";

        pushAIChat(`Perfect! Creating role "${pending.name}"...`);
        speak(`Creating role ${pending.name}.`);

        window.dispatchEvent(
            new CustomEvent("ai-create-role", {
                detail: {
                    RoleName: pending.name,
                    Status: status
                }
            })
        );

        setPendingRole(null);
        return;
    }
};
// -------------------------------
// DELETE ROLE — START
// -------------------------------
export const startDeleteRoleFlow = (
    setPendingDelete: (data: PendingDeleteRole | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void,
    nameFromIntent?: string
) => {
    if (nameFromIntent) {
        pushAIChat(`Deleting role "${nameFromIntent}"...`);
        speak(`Deleting role ${nameFromIntent}.`);

        window.dispatchEvent(
            new CustomEvent("ai-delete-role", {
                detail: { name: nameFromIntent }
            })
        );
        return;
    }

    setPendingDelete({ awaitingName: true });
    pushAIChat("Which role would you like to delete?");
    speak("Which role would you like to delete?");
};
// -------------------------------
// DELETE ROLE — PROCESS
// -------------------------------
export const processPendingDeleteRole = (
    text: string,
    pending: PendingDeleteRole,
    setPendingDelete: (data: PendingDeleteRole | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void
) => {
    if (!pending.awaitingName) return;

    const cleanName = text.replace(/[^a-zA-Z0-9 ]/g, "").trim();

    if (!cleanName) {
        pushAIChat("Please provide a valid role name.");
        speak("Please provide a valid role name.");
        return;
    }

    pushAIChat(`Deleting role "${cleanName}"...`);
    speak(`Deleting role ${cleanName}.`);

    window.dispatchEvent(
        new CustomEvent("ai-delete-role", {
            detail: { name: cleanName }
        })
    );

    setPendingDelete(null);
};
